import Swiper, { Navigation, Pagination } from "swiper";
import { qsa, qs } from "../utils/dom";

interface SwiperGeneralConfig {
	slidesPerView?: number;
	spaceBetween?: number;
	loop?: boolean;
	centeredSlides?: boolean;
	noSwiping?: boolean;
}

interface SwiperConfig extends SwiperGeneralConfig {
	breakpoints?: {
		[key: number]: SwiperGeneralConfig;
	};
}

const SwiperCarousel = {
	init: () => {
		const swipers = qsa(".swiper") as NodeListOf<HTMLElement>;
		if (swipers.length === 0) return;
		SwiperCarousel.loop(swipers);
	},

	loop: (elements: NodeListOf<HTMLElement>) => {
		elements.forEach((element) => {
			const pagination = qs(".swiper-pagination", element) as HTMLElement;
			const { swiperConfig } = element.dataset;
			let parsedConfig: SwiperConfig = {};

			if (typeof swiperConfig !== "undefined") {
				parsedConfig = JSON.parse(swiperConfig);
			}

			new Swiper(element, {
				modules: [Navigation, Pagination],
				loop: parsedConfig.loop ?? false,
				slidesPerView: parsedConfig.slidesPerView ?? 1,
				spaceBetween: parsedConfig.spaceBetween ?? 0,
				centeredSlides: parsedConfig.centeredSlides ?? false,
				noSwiping: parsedConfig.noSwiping ?? false,
				noSwipingClass: "swiper-slide",
				pagination: {
					el: pagination,
					clickable: true,
				},
				breakpoints: parsedConfig.breakpoints,
			});
		});
	},
};

export default SwiperCarousel;
